export enum DNGateResult {
    Match = 'Match',
    NotFound = 'NotFound',
    Mismatch = 'Mismatch',
    FoundButNotSure = 'FoundButNotSure',
}
